<template>
  <div class="page-container">
    <section id="section__complete-documents">
      <StaticGuide>
        <template #contents>
          <v-row no-gutters class="py-8">
            <v-col cols="12" class="text-center" style="margin-bottom: 2rem">
              <img src="@/assets/images/guide/pencil_01.png" alt="연필" />
            </v-col>

            <v-col cols="12" class="text-center" style="padding-bottom: 3rem">
              <p class="mb-4 font--m-1 font-weight-bold">
                서류 제출이 <br />
                완료되었어요!!
              </p>
              <p class="mb-1">서비스 제공을 위해</p>
              <p class="mb-1">상담사가 곧 연락드릴 예정입니다.</p>
              <p class="mb-0">
                <span class="font-weight-black">02-6925-1788</span>
                에서 걸려오는 전화를 받아주세요!
              </p>
            </v-col>
          </v-row>
        </template>

        <template #activator>
          <v-row no-gutters>
            <v-col cols="12">
              <BasicButton id="btn__BzQ99LMYRUmBwhgP6ylfTw" @click="close()"> 닫기 </BasicButton>
            </v-col>
          </v-row>
        </template>
      </StaticGuide>
    </section>
  </div>
</template>

<script>
import { closeBrowser } from '@/util'
import StaticGuide from '@/components/common/guide/StaticGuide.vue'

export default {
  components: {
    StaticGuide,
  },
  methods: {
    close() {
      closeBrowser()
    },
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  background-color: white;
}
</style>
